import styled from 'styled-components';
import StuartColors from '@packages/styles/colors';

const StyledApp = styled.div`
    background: ${StuartColors.LightGrey};
    font: 14px/1.5 Roboto, sans-serif;
    button.ant-btn-primary {
        background-color: ${StuartColors.DarkBlue};
        border-color: ${StuartColors.DarkBlue};
    }
    .font-size--small {
        font-size: 13px;
    }
`;

export default StyledApp;
